import component from "./BankPayout.vue";
import { formFields, listField } from "./config";

export default {
  component,
  listField,
  formFields,
};

export const selector = (selectedPayoutSystem: string | null): boolean => {
  return selectedPayoutSystem === "bank";
};
